import {Component, OnDestroy} from "@angular/core";
import {FUIFormationService} from "./formation.service";
import {FUIResponsiveService} from "../../page/responsive.service";
import {Subscription} from "rxjs";
import {FUIBreakpoints} from "../../page/breakpoints.model";

@Component({
    selector: "fui-formation",
    styleUrls: ["./formation.component.scss"],
    templateUrl: "./formation.component.html",
    standalone: false
})
export class FUIFormationComponent implements OnDestroy {
    private subscriptions: Subscription = new Subscription();

    public hasNavigation: boolean;

    constructor(private formationService: FUIFormationService,
                private responsiveService: FUIResponsiveService) {
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => this.hasNavigation = this.responsiveService.breakpointApplies(FUIBreakpoints.mediumUp)));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
